import React from 'react'
import * as Buttons from './buttons/index';

export default class Formulas extends React.Component {

    render() {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.SolidRate />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.PropertyCalculation />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.DensityCorrection />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.UnitConverter />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.MolarMass />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.ProcessYield />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.BreakTime />
                </div>
                <div className="col-sm-12 col-md-6 col-xl-4">
                    <Buttons.Documents />
                </div>
            </div>
        )
    }
}